(() => {
  const init = (root) => {
    if (!root || root.dataset.tanOutdoorReady === 'true') return;
    root.dataset.tanOutdoorReady = 'true';

    const options = Array.from(root.querySelectorAll('[data-outdoor-option]'));
    const results = Array.from(root.querySelectorAll('[data-outdoor-result]'));
    const briefOutput = root.querySelector('[data-tan-brief-output]');
    if (!options.length || !results.length) return;

    const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
    const interpolate = (template, values = {}) => Object.entries(values).reduce(
      (output, [name, value]) => output.split(`{${name}}`).join(String(value)),
      String(template || ''),
    );
    let i18n = {};
    try {
      i18n = JSON.parse(root.querySelector('[data-tan-outdoor-copy]')?.textContent || '{}');
    } catch (_) {
      i18n = {};
    }

    const select = (key, moveFocus = false) => {
      options.forEach((option) => {
        const active = option.dataset.outdoorOption === key;
        option.classList.toggle('is-active', active);
        option.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active && moveFocus) option.focus({ preventScroll: true });
      });

      results.forEach((result) => {
        const active = result.dataset.outdoorResult === key;
        result.hidden = !active;
      });

      if (briefOutput) {
        const option = options.find((candidate) => candidate.dataset.outdoorOption === key);
        const result = results.find((candidate) => candidate.dataset.outdoorResult === key);
        const details = Array.from(result?.querySelectorAll('.tan-outdoor-fit__brief li') || [])
          .map((item) => clean(item.textContent))
          .filter(Boolean);
        briefOutput.value = [
          i18n.brief?.title,
          interpolate(i18n.brief?.environment, { value: clean(option?.querySelector('strong')?.textContent) }),
          interpolate(i18n.brief?.environmentSummary, { value: clean(option?.querySelector('small')?.textContent) }),
          '',
          interpolate(i18n.brief?.planningDirection, { value: clean(result?.querySelector('.tan-outdoor-fit__recommendation h3')?.textContent) }),
          clean(result?.querySelector('.tan-outdoor-fit__recommendation div')?.textContent),
          '',
          interpolate(i18n.brief?.siteDetails, { value: details.join(i18n.listSeparator || '') }),
          '',
          i18n.brief?.attachments,
        ].filter(Boolean).join('\n');
      }
    };

    options.forEach((option, index) => {
      option.addEventListener('click', () => select(option.dataset.outdoorOption));
      option.addEventListener('keydown', (event) => {
        if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = options.length - 1;
        else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % options.length;
        else nextIndex = (index - 1 + options.length) % options.length;
        select(options[nextIndex].dataset.outdoorOption, true);
      });
    });

    const initial = options.find((option) => option.getAttribute('aria-pressed') === 'true') || options[0];
    select(initial.dataset.outdoorOption);
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-tan-outdoor-fit]')) init(scope);
    scope.querySelectorAll?.('[data-tan-outdoor-fit]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
